"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const classes_1 = require("../classes");
class WaitForExternalEventAction {
    constructor(externalEventName, reason = classes_1.ExternalEventType.ExternalEvent) {
        this.externalEventName = externalEventName;
        this.reason = reason;
        this.actionType = classes_1.ActionType.WaitForExternalEvent;
        classes_1.Utils.throwIfEmpty(externalEventName, "externalEventName");
    }
}
exports.WaitForExternalEventAction = WaitForExternalEventAction;
//# sourceMappingURL=waitforexternaleventaction.js.map